enum EnumMyleLoginPermission {
    Unknown,
    AdminTabPermission,
    AffectationTabPermission,
    BillingCostPermission,
    BillingTabPermission,
    BillingTabPermissionCurrentUserOnly,
    CalendarTabPermission,
    CommunicationsTabPermission,
    CanCreateAndEditPatientPermission,
    DocumentTabPermission,
    InboundFaxPermission,
    ListsTabPermission,
    LabsTabPermission,
    PatientTabPermission,
    PortfolioTabPermission,
    PrescriptionRenewalTabPermission,
    PrivateBillingPermission,
    PublicBillingPermission,
    ReportingTabPermission,
    SettingsTabPermission,
    OrdersTabPermission,
    Administration_SiteTabPermission,
    Administration_ServiceCombosTabPermission,
    Administration_UsersTabPermission,
    Administration_BillableServicesTabPermission,
    Administration_CommunicationGroupsTabPermission,
    Administration_QuestionnairesTabPermission,
    Administration_LogsTabPermission,
    Administration_ExternalConsultationTabPermission,
    Administration_PatientMergeRequestPermission,
    Administration_RolesTabPermission
}

export { EnumMyleLoginPermission };
